import { render, staticRenderFns } from "./FxGame.vue?vue&type=template&id=65ba8254&scoped=true"
import script from "./FxGame.vue?vue&type=script&lang=js"
export * from "./FxGame.vue?vue&type=script&lang=js"
import style0 from "./FxGame.vue?vue&type=style&index=0&id=65ba8254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba8254",
  null
  
)

export default component.exports